import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query'
import { blogService, BlogPost } from '@/services/other-services'
import { toast } from 'sonner'

export function useBlog(params?: { search?: string; page?: number }) {
    const queryClient = useQueryClient()

    const query = useQuery({
        queryKey: ['blog', params],
        queryFn: () => blogService.getAll(params),
        refetchInterval: (query) => {
            const data = query.state.data
            const hasTranslating = data?.items?.some((p: any) => p.isTranslating)
            return hasTranslating ? 5000 : false
        },
    })

    const createMutation = useMutation({
        mutationFn: blogService.create,
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: ['blog'] })
            toast.success('Yeni blog yazısı oluşturuldu')
        },
        onError: () => toast.error('Yazı oluşturulurken bir hata oluştu'),
    })

    const updateMutation = useMutation({
        mutationFn: ({ id, data }: { id: string; data: Partial<BlogPost> }) =>
            blogService.update(id, data),
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: ['blog'] })
            toast.success('Blog yazısı güncellendi')
        },
        onError: () => toast.error('Güncelleme sırasında bir hata oluştu'),
    })

    const deleteMutation = useMutation({
        mutationFn: blogService.delete,
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: ['blog'] })
            toast.success('Blog yazısı silindi')
        },
        onError: () => toast.error('Silme işlemi sırasında bir hata oluştu'),
    })

    const publishMutation = useMutation({
        mutationFn: ({ id, isPublished }: { id: string; isPublished: boolean }) =>
            blogService.setPublishStatus(id, isPublished),
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: ['blog'] })
            toast.success('Yayın durumu güncellendi')
        },
        onError: () => toast.error('Durum güncellenirken bir hata oluştu'),
    })

    return {
        ...query,
        createPost: createMutation.mutateAsync,
        updatePost: updateMutation.mutateAsync,
        deletePost: deleteMutation.mutateAsync,
        setPublishStatus: publishMutation.mutateAsync,
        isMutating: createMutation.isPending || updateMutation.isPending || deleteMutation.isPending || publishMutation.isPending,
    }
}
